import clsx from "clsx";
import { FC } from "react";

export type ChipKind =
  | "blue"
  | "hibiscus"
  | "hibiscusBorderless"
  | "moss"
  | "mossBorderless"
  | "orange"
  | "red"
  | "white"
  | "gray";

const KIND_CLASSES: Record<ChipKind, string> = {
  blue: "text-blue bg-blue-tint-95 border-blue-tint-70",
  hibiscus: "text-hibiscus bg-hibiscus-tint-95 border-hibiscus-tint-70",
  hibiscusBorderless: "text-hibiscus bg-hibiscus-tint-95 border-hibiscus-tint-95",
  moss: "text-moss bg-moss-tint-95 border-moss-tint-70",
  mossBorderless: "text-moss bg-moss-tint-93 border-moss-tint-93",
  orange: "text-orange-shade-40 bg-orange-tint-90 border-orange-tint-70",
  red: "text-red-shade-20 bg-red-tint-93 border-red-tint-70",
  white: "text-black-tint-20 bg-black-tint-99 border-black-tint-90",
  gray: "text-black-tint-55 bg-black-tint-97 border-black-tint-90",
};

const BASE_CHIP_CLASSNAME =
  "text-xs font-medium flex cursor-default items-center justify-center gap-1.5 whitespace-nowrap rounded-3xl border px-3 h-[28px]";

type ChipProps = {
  kind: ChipKind;
  children: React.ReactNode;
};

// For chips that are buttons, use chip kinds in Button.tsx
export const Chip: FC<ChipProps> = ({ children, kind }) => {
  return <div className={clsx(BASE_CHIP_CLASSNAME, KIND_CLASSES[kind])}>{children}</div>;
};
